import { useEffect, useState } from 'react';
import { AlbumType } from '../../../types/models';
import { Area } from './components/Area/Area';
import {
  apiAlbumsGet,
  apiPhotoCountrySearch,
  apiPhotoCitiesSearch,
} from '../../../actions/photoActions';
import { apiUserSearch } from '../../../actions/userActions';
import TableSearchField from '../../../components/table/TableSearchField';
import PageNotFound from '../../pagenotfound/PageNotFound';
import { useSelector } from 'react-redux';
import ReactPaginate from 'react-paginate';
import axios from 'axios';
import { NavLink } from 'react-router-dom';
import TableFilters from '../../../components/table/TableFilters';
import { TableFilter, TablePreset } from '../../../components/table/TablePage';
import moment from 'moment';

const elementsOnPage = 10;

const CancelToken = axios.CancelToken;
let source: any;

const configFilters: TableFilter[] = [
  {
    id: 'Status',
    type: 'select',
    label: 'Status',
    options: {
      label: 'Please select status',
      elements: ['On moderation', 'Approved', 'Declined', 'On Hold'],
    },
  },
  {
    id: 'Country',
    type: 'search',
    label: 'Country',
    options: {
      label: 'Please search country',
      onSearch: apiPhotoCountrySearch,
    },
  },
  {
    id: 'City',
    type: 'search',
    label: 'City',
    options: {
      label: 'Please search city',
      onSearch: apiPhotoCitiesSearch,
    },
  },
  {
    id: 'Filming At',
    type: 'date',
    label: 'Filming At',
  },
  {
    id: 'Uploaded At',
    type: 'date',
    label: 'Uploaded At',
  },
  {
    id: 'Email',
    type: 'search',
    label: 'Email',
    options: {
      label: 'Please search email',
      onSearch: apiUserSearch,
      secured: true,
    },
  },
];

const configPresets: TablePreset[] = [
  {
    label: 'On moderation',
    filters: [
      {
        id: 'Status',
        label: 'Status',
        value: 'On moderation',
      },
    ],
  },
];

function PanelPhotos() {
  const [albums, setAlbums] = useState<AlbumType[]>([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [search, setSearch] = useState('');
  const [filters, setFilters] = useState<any>([]);

  useEffect(() => {
    const getPreparedFilters = () => {
      return JSON.stringify(
        filters.map((filter: any) =>
          JSON.stringify({
            id: filter.id,
            value:
              filter.type !== 'date'
                ? filter.value
                : JSON.stringify({
                    start:
                      filter.value.start !== null
                        ? moment(filter.value.start).format('YYYY-MM-DD')
                        : null,
                    end:
                      filter.value.end !== null
                        ? moment(filter.value.end).format('YYYY-MM-DD')
                        : null,
                  }),
          })
        )
      );
    };

    const getAlbums = async () => {
      if (source) {
        source.cancel();
      }

      source = CancelToken.source();

      setLoading(true);
      const data = await apiAlbumsGet({
        limit: elementsOnPage,
        offset: page * elementsOnPage,
        cancelToken: source.token,
        search,
        filters: getPreparedFilters(),
      });
      setAlbums(data.albums);
      setCount(data.count);
      setLoading(false);
    };

    getAlbums();
  }, [page, search, filters]);

  const pagination = (
    <div className="table-page-paginations">
      <ReactPaginate
        forcePage={page}
        breakLabel="..."
        nextLabel=">"
        onPageChange={event => {
          setPage(event.selected);
        }}
        pageRangeDisplayed={3}
        pageCount={Math.ceil(count / elementsOnPage)}
        previousLabel="<"
      />
    </div>
  );

  const user = useSelector(state => state.user);

  if (user.user && parseInt(user.user.admin) === 0 && parseInt(user.user.ugc) === 0) {
    return <PageNotFound />;
  }

  return (
    <>
      <div className="table-page">
        <div className="table-page-top row">
          <span className="table-page-top-title">Photos</span>
          <button className="table-page-button table-page-create-button">
            <span className="table-page-button-label">Create album</span>
            <img className="table-page-button-icon" src="/images/create-button-icon.svg" alt="" />
          </button>
          <NavLink to="/photo/upload" className="table-page-button table-page-create-button">
            <span className="table-page-button-label">Upload photo</span>
            <img className="table-page-button-icon" src="/images/create-button-icon.svg" alt="" />
          </NavLink>
          <TableSearchField
            search={search}
            onChange={(value: string) => {
              setPage(0);
              setSearch(value);
            }}
          />
          <div className="table-page-top-right">
            {count > elementsOnPage && pagination}
            <span className="table-page-num-value">
              Total num: <b>{count}</b>
            </span>
          </div>
        </div>
        {configPresets.length > 0 && (
          <div className="table-page-presets">
            {configPresets.map((preset: any) => {
              return (
                <span
                  key={preset.label}
                  className="table-page-presets-element"
                  onClick={() => {
                    setPage(0);
                    setFilters([...preset.filters]);
                  }}
                >
                  #{preset.label}
                </span>
              );
            })}
          </div>
        )}
        <div className="table-page-dop-row row" style={{ paddingBottom: '20px' }}>
          <TableFilters
            configs={configFilters}
            filters={filters}
            onChange={(filters: any) => {
              setPage(0);
              setFilters(filters);
            }}
          />
        </div>
      </div>
      {loading ? (
        <div className="table-page-loader">
          <div className="lds-ripple">
            <div />
            <div />
          </div>
        </div>
      ) : (
        albums.map(album => <Area key={album.id} album={album} />)
      )}
      <div style={{ marginTop: '20px' }}>{count > elementsOnPage && pagination}</div>
    </>
  );
}

export default PanelPhotos;
